// 极验滑块验证
import '@src/common/utils/gt'
import React, { FC, useEffect, useState } from 'react'
import { Spin } from 'antd'
import { initSliderCaptcha } from './utils'
import styles from './index.module.less'
import { IProps } from './const'

/**
 * 滑块验证
 * @constructor
 */
const CaptchaSlider: FC<IProps> = ({ onFinish, changeCaptchaToImage }) => {
  // 滑块验证码是否已经添加到页面中
  const [ready, setReady] = useState(false)
  const [ref, setRef] = useState<HTMLDivElement | null>(null)
  // 组件是否被销毁
  let destroy = false

  useEffect(() => {
    if (ref) {
      initSliderCaptcha(ref, {
        onReady: () => {
          if (destroy) {
            return
          }
          setReady(true)
        },
        onSuccess: (result) => {
          onFinish({
            slideChallenge: result.geetest_challenge,
            slideSecCode: result.geetest_seccode,
            slideValidate: result.geetest_validate,
            reset: () => {
              result.gt.reset()
              onFinish(null)
            }
          })
        },
        changeCaptchaToImage
      })
    }
    return () => {
      destroy = true
    }
  }, [ref])

  return (
    <div
      className={styles.wrap}
      ref={el => {
        setRef(el)
      }}
    >
      {
        !ready && (
          <div className={styles.captchaPlaceholder}>
            <Spin />
          </div>
        )
      }
    </div>
  )
}

export default CaptchaSlider
